<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>{{ pageVocabs + "legend" | translate }}</legend>
          <div class="row">
            <!-- users -->
            <div class="md:tw-w-1/2">
              <users-select-search
                type="listDescendant"
                [control]="form?.get('userId')"
                [(value)]="model.userId"
                [removable]="!formPageConfig.isEditMode"
                [isDisabled]="formPageConfig.isEditMode"
                (onError)="onClose()"
              >
              </users-select-search>
            </div>

            <!-- times -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="ResellerTargetTimes"
                [label]="fields + 'times'"
                [control]="form?.get('times')"
                [(value)]="model.times"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- credit -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.credit"
                [label]="fields + 'credit'"
                [hasCurrency]="true"
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('credit')"
              >
              </form-field>
            </div>

            <!-- targetValue -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.targetValue"
                [label]="fields + 'targetValue'"
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('targetValue')"
              >
              </form-field>
            </div>

            <!-- start date time picker -->
            <div class="xl:tw-w-1/2 md:tw-w-2/3">
              <app-periodic-date-picker
                class="row"
                [config]="periodicDateConfig"
                (startDate)="model.startDateTime = $event"
                (endDate)="model.endDateTime = $event"
              >
              </app-periodic-date-picker>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
